import { Injectable } from '@angular/core';

/*
  Generated class for the StyleLoaderProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StyleLoaderProvider {

  constructor() {
    console.log('Hello StyleLoaderProvider Provider');
  }

  /**
   * Cssファイルを追加
   * 
   * @param csspath 追
   */
  public loadCssFile(csspath: string){
    let link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", csspath);
    document.head.appendChild(link);
  }

  /**
   * styleを直に追加
   * 
   * @param style 
   */
  public writeStyles(style: string){
    let dom = document.createElement("style");
    dom.setAttribute("type", "text/css");
    dom.innerHTML = style;
    document.head.appendChild(dom);
  }
}



// WEBPACK FOOTER //
// ./src/providers/style-loader/style-loader.ts